export const endPoints = {
  DEBT: '/v1/debt',
  DEBT_EXCEL: '/v1/debt/excel/',
  DEBT_MONTHLY_EXCEL: '/v1/debt/monthly/excel/',
  DEBT_EXCEL_BETA: '/v1/debt/in-date/excel/beta',
  DEBT_SEND_MESSAGE: '/v1/debt/send-message',
  CONTRACT: '/v1/contract/',
  UPDATE_CLIENT_LEVEL: '/v1/client/update/level'
};
